import { render, staticRenderFns } from "./UpsellingOptions.vue?vue&type=template&id=e309c1da&scoped=true"
import script from "./UpsellingOptions.vue?vue&type=script&lang=js"
export * from "./UpsellingOptions.vue?vue&type=script&lang=js"
import style0 from "./UpsellingOptions.vue?vue&type=style&index=0&id=e309c1da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e309c1da",
  null
  
)

export default component.exports